//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RedAPI from '@/api/promotores/usuarios/red.api'
export default {
	data() {
		return {
			invitados: [],
			loading: false,
		}
	},

	mounted() {
		this.loadRed();
	},

	methods: {
		async loadRed() {
			try {
				this.loading = true
				this.invitados = await RedAPI.invitados(this.$route.params.promotor)
			} finally {
				this.loading = false
			}
		},

		clickInvitado(invitado) {
			this.$router.push({ name: 'promotor', params: { promotor: invitado.id } })
		}
	},
}
